import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"
import _imports_0 from '../assets/pitchyou-logo.png'


const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "row justify-center full-width" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "logo" }, [
    /*#__PURE__*/_createElementVNode("a", {
      href: "https://www.pitchyou.de",
      target: "_blank"
    }, [
      /*#__PURE__*/_createElementVNode("img", {
        src: _imports_0,
        class: "img-fluid"
      })
    ])
  ])
], -1)
const _hoisted_2 = { class: "row full-width justify-center items-center" }
const _hoisted_3 = {
  class: "text-white q-pa-sm",
  href: "https://www.pitchyou.de/impressum",
  target: "_blank"
}
const _hoisted_4 = {
  class: "text-white q-pa-sm",
  href: "https://www.pitchyou.de/datenschutz",
  target: "_blank"
}
const _hoisted_5 = { class: "copyright text-center q-pa-md q-mt-xs bg-secondary" }

import { ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'BrandFooter',
  props: ['showTermsOfUse'],
  setup(__props) {

const name = ref<string>('BrandFooter');
const props = __props;
const showTermsOfUse = ref<boolean | undefined>(props.showTermsOfUse);
function currentYear() {
  return new Date().getFullYear();
}

return (_ctx: any,_cache: any) => {
  const _component_q_footer = _resolveComponent("q-footer")!

  return (_openBlock(), _createBlock(_component_q_footer, {
    elevated: "",
    class: "bg-secondary text-white q-pt-md q-mt-lg"
  }, {
    default: _withCtx(() => [
      _hoisted_1,
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", null, [
          _createElementVNode("a", _hoisted_3, _toDisplayString(_ctx.$t('message.legalNoticeFLbl')), 1),
          _createElementVNode("a", _hoisted_4, _toDisplayString(_ctx.$t('message.privacyPolicyFLbl')), 1),
          _withDirectives(_createElementVNode("a", {
            class: "text-white q-pa-sm",
            href: "https://www.pitchyou.de/nutzungsbedingungen",
            target: "_blank"
          }, _toDisplayString(_ctx.$t('message.termsOfUseFLbl')), 513), [
            [_vShow, showTermsOfUse.value]
          ])
        ]),
        _createElementVNode("div", _hoisted_5, " © " + _toDisplayString(currentYear()) + " PitchYou GmbH ", 1)
      ])
    ]),
    _: 1
  }))
}
}

})